// Lazuz on Shrine: the behaviour Shrine has no setting for. No tracking, no storage; the one network call is adding to the cart from the hero buy box (r7).
// - ?a=<n>: swaps the hero opening and the story to the block made for that angle (quiz answers and ads).
// - ?tried=1|2: shows the previous-support module; ?from=quiz: shows the link back to the quiz.
// - #offer / #how / #faq: in-page links to the buy area and to sections by their template key.
// - Campaign parameters (utm_*, fbclid, gclid, ttclid) stay on links between the quiz and the pages.
// - Pause button on every looping video (WCAG 2.2.2); reduced motion = no autoplay.
// - "More reviews" on the demo review list (sections/lazuz-demo-reviews.liquid).
// - The quiz (sections/lazuz-quiz.liquid).
(() => {
  if (window.__lazuz) return; window.__lazuz = true;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const params = new URLSearchParams(location.search);
  const initHash = location.hash; // read before the quiz rewrites the address (review 2, R2-13)
  const keep =[...params].filter(([k]) => /^(utm_|fbclid|gclid|ttclid)/.test(k));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const withKeep = (url, extra = {}) => {
    const u = new URL(url, location.origin);
    keep.forEach(([k, v]) => u.searchParams.set(k, v));
    Object.entries(extra).forEach(([k, v]) => (v === null || v === undefined || v === '') ? u.searchParams.delete(k) : u.searchParams.set(k, v));
    return u.pathname + u.search + u.hash;
  };

  // Shrine rewrites the address to "?variant=…" on every variant change, which drops the page's own parameters.
  // Keep them (view, quiz answers, campaign, preview), so a refresh or a shared link opens the same page.
  const KEEP_ON_VARIANT = /^(view|a|tried|from|lzpub|utm_|fbclid|gclid|ttclid|preview_theme_id|pb)/;
  for (const fn of ['replaceState', 'pushState']) {
    const orig = history[fn].bind(history);
    history[fn] = (state, title, url) => {
      try {
        if (url) {
          const u = new URL(url, location.href);
          if (u.pathname === location.pathname && u.searchParams.has('variant')) {
            new URLSearchParams(location.search).forEach((v, k) => { if (KEEP_ON_VARIANT.test(k) && !u.searchParams.has(k)) u.searchParams.set(k, v); });
            url = u.pathname + u.search + u.hash;
          }
        }
      } catch (e) { /* leave the theme's URL as it is */ }
      return orig(state, title, url);
    };
  }

  const ready = fn => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn());
  ready(() => {
    // ---------- openings and story by angle ----------
    const a = (params.get('a') || '').trim();
    if (a) {
      $$('[data-lz-hero]').forEach(hero => {
        const tpl = $$('template[data-lz-opening]', hero).find(t => t.dataset.lzOpening === a);
        if (!tpl) return;
        $$('[data-lz-swap]', tpl.content).forEach(el => {
          const key = el.dataset.lzSwap;
          const target = $(`.lz-hero__grid [data-lz-swap="${key}"]`, hero);
          if (target) target.replaceWith(el.cloneNode(true));
          else if (key === 'kicker') { const h = $('.lz-hero__grid h1', hero); h && h.before(el.cloneNode(true)); }
        });
        const h1 = $('.lz-hero__grid h1', hero); if (h1 && !h1.id) h1.id = 'lz-h1';
      });
      $$('template[data-lz-story-for]').forEach(t => {
        if (t.dataset.lzStoryFor !== a) return;
        const box = t.closest('.lz-story') && $('[data-lz-story]', t.closest('.lz-story'));
        if (box) box.replaceChildren(t.content.cloneNode(true));
      });
    }

    // ---------- previous-support module ----------
    const tried = params.get('tried');
    $$('[data-lz-tried]').forEach(sec => {
      // r5: the quiz answer wins; otherwise an ad angle about a previous brace, or "always" (support), opens version 1
      const angles = (sec.dataset.lzTriedAngles || '').split(/\s+/).filter(Boolean);
      const v = tried === '1' || tried === '2' ? tried
        : (a && angles.includes(a)) || sec.dataset.lzTriedAlways === 'true' ? '1' : null;
      let any = false;
      $$('[data-lz-tried-variant]', sec).forEach(el => { el.hidden = el.dataset.lzTriedVariant !== v; any = any || !el.hidden; });
      sec.hidden = !any;
    });

    // ---------- publish-state preview (r5): ?lzpub=1 shows what the live theme will show ----------
    // Demo content (reviews, the draft notice) is decided on the server by theme role, so the preview always has it.
    // With ?lzpub=1 the preview hides it and shows the live-only lines instead, to check the publish state without publishing.
    if (params.get('lzpub') === '1') {
      $$('[data-review-type="demo"], .lz-preview-note').forEach(el => el.remove());
      $$('[data-lz-live-only]').forEach(el => { el.hidden = false; });
    }

    // ---------- back to the quiz ----------
    if (params.get('from') === 'quiz') $$('[data-lz-from-quiz]').forEach(el => { el.hidden = false; el.href = withKeep(el.getAttribute('href') || '/', { step: '1' }); });

    // ---------- in-page links ----------
    const targetFor = hash => {
      if (hash === '#offer') return $('product-info, .product__info-wrapper, [id$="__main"]') || $('[id$="__main"]');
      const key = hash.slice(1);
      return document.getElementById(key) || $(`[id$="__${CSS.escape(key)}"]`);
    };
    // "#offer" lands on the buy area's heading, not on the gallery's first button (review 2, R2-06)
    const focusIn = (hash, t) => (hash === '#offer' && $('.product__info-wrapper :is(h1, h2), .product__info-container :is(h1, h2)', t)) || t.querySelector('h1, h2, h3, input, button');
    const goTo = (hash, smooth) => {
      const t = targetFor(hash);
      if (!t) return false;
      t.scrollIntoView({ behavior: smooth && !reduce ? 'smooth' : 'auto', block: 'start' });
      const focusable = focusIn(hash, t);
      if (focusable) { focusable.setAttribute('tabindex', focusable.getAttribute('tabindex') || '-1'); focusable.focus({ preventScroll: true }); }
      return true;
    };
    document.addEventListener('click', e => {
      const link = e.target.closest('a[href^="#"]');
      if (!link || link.getAttribute('href').length < 2) return;
      if (goTo(link.getAttribute('href'), true)) e.preventDefault();
    });
    // a link from outside with a hash (an ad to "/#quiz", the menu's "#offer"): sections have no plain ids, so the
    // browser cannot scroll there by itself (review 2, R2-13)
    if (initHash.length > 1 && !document.getElementById(initHash.slice(1))) addEventListener('load', () => setTimeout(() => goTo(initHash, false), 50), { once: true });

    // ---------- videos: pause button, play only while visible ----------
    // reduced motion: no video starts by itself, the theme's own ones included (review 2, R2-21)
    if (reduce) {
      $$('main video').forEach(v => { v.autoplay = false; v.removeAttribute('autoplay'); v.pause(); });
      // Shrine starts its videos when they scroll into view; only the reader's own play button may start one
      document.addEventListener('click', e => { const b = e.target.closest('.lz-vbtn, .internal-video__play'); const v = b && b.parentElement && b.parentElement.querySelector('video'); if (v && v.paused) v.dataset.user = 'play'; }, true);
      document.addEventListener('play', e => { const v = e.target; if (v.tagName === 'VIDEO' && v.dataset.user !== 'play') v.pause(); }, true);
    }
    const vids = $$('.lz-media video, .image-with-text__media video');
    vids.forEach(v => {
      v.muted = true; v.playsInline = true;
      if (reduce) { v.autoplay = false; v.removeAttribute('autoplay'); v.pause(); }
      const box = v.closest('.lz-media, .image-with-text__media');
      if (!box || box.querySelector('.lz-vbtn')) return;
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'lz-vbtn';
      const label = () => { b.setAttribute('aria-label', v.paused ? 'הפעלת הסרטון' : 'עצירת הסרטון'); b.dataset.state = v.paused ? 'paused' : 'playing'; };
      b.addEventListener('click', () => { v.dataset.user = v.paused ? 'play' : 'pause'; v.paused ? v.play().catch(() => {}) : v.pause(); });
      v.addEventListener('play', label); v.addEventListener('pause', label);
      box.append(b); label();
    });
    if (!reduce && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => es.forEach(({ target: v, isIntersecting }) => {
        if (isIntersecting) { if (v.dataset.user !== 'pause') v.play().catch(() => {}); }
        else if (!v.paused) v.pause();
      }), { threshold: 0.35 });
      vids.forEach(v => io.observe(v));
    }

    // ---------- choosing the pack, side and size (on top of Shrine's variant picker) ----------
    // Shopify always has a selected variant, so a size always looks chosen. Here:
    // - until the reader picks a side and a size, those buttons show nothing selected and the labels say "בחר צד" /
    //   "בחר מידה"; "add to cart" asks for what is missing instead of adding right / M by default;
    // - in the pair, the 16 combined buttons ("ימין L · שמאל XL") are replaced by two rows, one per knee; when both
    //   are picked, the matching combined button is clicked so Shrine sets the real variant (price, cart, URL);
    // - each pack card shows its caption as fixed lines (split on " · ").
    // Shrine updates the picker in place after every change, so everything is re-applied after each update.
    const vsel = $('variant-selects');
    if (vsel) {
      const SIZES = ['M', 'L', 'XL', 'XXL'];
      const st = { chosen: false, side: false, pair: null, r: null, l: null };
      const group = prefix => { const i = $$('input', vsel).find(x => x.name && x.name.startsWith(prefix)); return i && i.closest('.product-form__input'); };
      const packValue = () => { const i = $$('input', vsel).find(x => x.name && x.name.startsWith('חבילה') && x.checked); return i ? i.value : ''; };
      const clearError = () => $$('.lz-size-error').forEach(e => e.remove());
      const setLabel = (g, text) => { const s = g && g.querySelector('.form__label span, .form__label'); if (s && s.textContent.trim() !== text) s.textContent = text; };
      const clickNative = value => { const i = $$('input', vsel).find(x => x.name && x.name.startsWith('מידה') && x.value === value); const lab = i && vsel.querySelector(`label[for="${CSS.escape(i.id)}"]`); if (lab) lab.click(); };
      const pairRows = g => {
        let box = g.parentElement.querySelector(':scope > .lz-fit');
        if (!box) {
          box = document.createElement('div');
          box.className = 'lz-fit';
          box.innerHTML = ['r', 'l'].map(k => `<div class="lz-fit__row" data-knee="${k}"><p class="lz-fit__label"></p><div class="lz-fit__pills" role="radiogroup" aria-label="${k === 'r' ? 'מידה לברך ימין' : 'מידה לברך שמאל'}">${SIZES.map(s => `<button type="button" class="lz-fit__pill" role="radio" aria-checked="false" data-size="${s}">${s}</button>`).join('')}</div></div>`).join('');
          box.addEventListener('click', e => {
            const b = e.target.closest('.lz-fit__pill'); if (!b) return;
            const k = b.closest('.lz-fit__row').dataset.knee;
            st[k] = b.dataset.size;
            if (st.r && st.l) { st.chosen = true; clearError(); clickNative(`ימין ${st.r} · שמאל ${st.l}`); }
            sync();
          });
          g.after(box);
        }
        for (const row of $$('.lz-fit__row', box)) {
          const k = row.dataset.knee, v = st[k];
          row.querySelector('.lz-fit__label').textContent = `${k === 'r' ? 'ברך ימין' : 'ברך שמאל'}: ${v || 'בחר מידה'}`;
          $$('.lz-fit__pill', row).forEach(p => p.setAttribute('aria-checked', String(p.dataset.size === v)));
        }
        return box;
      };
      let syncing = false;
      const sync = () => {
        if (syncing) return; syncing = true;
        try {
          const pair = /שתי|תזוזה/.test(packValue()); // r6: the pair is "ערכת תזוזה מלאה"
          if (st.pair !== null && pair !== st.pair) { st.chosen = false; st.side = false; st.r = st.l = null; }
          st.pair = pair;
          const sideG = group('צד'), sizeG = group('מידה');
          // each group of buttons is a named radio group; the label's "for" pointed at an id that does not exist (R2-11)
          [[group('חבילה'), 'חבילה'], [sideG, 'צד'], [sizeG, 'מידה']].forEach(([g, name], n) => {
            if (!g) return;
            const lab = g.querySelector('.form__label');
            if (lab) { if (lab.hasAttribute('for')) lab.removeAttribute('for'); if (!lab.id) lab.id = `lz-opt-label-${n}`; }
            if (g.getAttribute('role') !== 'radiogroup') g.setAttribute('role', 'radiogroup');
            if (lab) { if (g.getAttribute('aria-labelledby') !== lab.id) g.setAttribute('aria-labelledby', lab.id); }
            else if (g.getAttribute('aria-label') !== name) g.setAttribute('aria-label', name);
          });
          if (sideG) {
            sideG.classList.toggle('lz-hide', pair);
            sideG.classList.toggle('lz-size-pending', !pair && !st.side);
            if (!pair) setLabel(sideG, st.side ? `צד: ${($$('input', sideG).find(x => x.checked) || {}).value || ''}` : 'צד: בחר צד');
          }
          if (sizeG) {
            sizeG.classList.toggle('lz-hide', pair);
            sizeG.classList.toggle('lz-size-pending', !pair && !st.chosen);
            if (!pair) setLabel(sizeG, st.chosen ? `מידה: ${($$('input', sizeG).find(x => x.checked) || {}).value || ''}` : 'מידה: בחר מידה');
            const fit = sizeG.parentElement.querySelector(':scope > .lz-fit');
            if (pair) pairRows(sizeG).hidden = false; else if (fit) fit.hidden = true;
          }
          // pack names: the brand words in green, like everywhere else (r6: "תזוזה מלאה")
          $$('.quantity-break__label-text, .quantity-break__label', vsel).forEach(l => {
            if (l.children.length) return; // only a plain text name, never a box with the price or the tag inside
            const t = l.textContent; if (!/לזוז|תזוזה מלאה/.test(t)) return;
            l.innerHTML = t.replace(/[<>&]/g, '').replace(/(תזוזה מלאה|לזוז)/, '<em>$1</em>');
          });
          // pack cards: caption as fixed lines
          $$('.quantity-break__caption', vsel).forEach(c => {
            if (c.querySelector('.lz-line')) return;
            const parts = c.textContent.split('·').map(s => s.trim()).filter(Boolean);
            if (parts.length > 1) c.innerHTML = parts.map(p => `<span class="lz-line">${p.replace(/[<>&]/g, '')}</span>`).join('');
          });
        } finally { syncing = false; }
      };
      document.addEventListener('change', e => {
        const t = e.target;
        if (t && t.name && t.name.startsWith('מידה') && !st.pair) { st.chosen = true; if (st.side) clearError(); }
        if (t && t.name && t.name.startsWith('צד') && !st.pair) { st.side = true; if (st.chosen) clearError(); }
        setTimeout(sync, 0);
      }, true);
      // picking the option Shopify already marks (right, M) fires no "change": count the click as the choice too
      vsel.addEventListener('click', e => {
        if (st.pair) return;
        const lab = e.target.closest('label');
        const i = e.target.closest('input') || (lab && (lab.htmlFor ? document.getElementById(lab.htmlFor) : lab.querySelector('input')));
        if (!i || !i.name) return;
        if (i.name.startsWith('צד')) st.side = true; else if (i.name.startsWith('מידה')) st.chosen = true; else return;
        if (st.side && st.chosen) clearError();
        setTimeout(sync, 0);
      }, true);
      new MutationObserver(() => { if (!syncing) requestAnimationFrame(sync); }).observe(vsel, { childList: true, subtree: true, characterData: true });
      sync();

      const guard = e => {
        const btn = e.type === 'submit' ? null : e.target.closest('product-form button[type="submit"], .product-form__submit, button[name="add"]');
        const form = e.type === 'submit' ? e.target : btn && btn.closest('form');
        if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
        const ready = st.pair ? st.chosen : st.chosen && st.side;
        if (ready) return;
        e.preventDefault(); e.stopImmediatePropagation();
        const box = st.pair ? vsel.querySelector('.lz-fit') : (!st.side ? group('צד') : group('מידה'));
        if (!box) return;
        clearError();
        const msg = document.createElement('p');
        msg.className = 'lz-size-error'; msg.setAttribute('role', 'alert');
        msg.textContent = st.pair ? 'בחר מידה לכל ברך לפי טבלת המידות, ואז הוסף לסל'
          : !st.side && !st.chosen ? 'בחר צד ומידה, ואז הוסף לסל'
          : !st.side ? 'בחר צד, ימין או שמאל, ואז הוסף לסל' : 'בחר מידה לפי טבלת המידות, ואז הוסף לסל';
        box.append(msg);
        box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        const first = box.querySelector('button, input'); first && first.focus({ preventScroll: true });
      };
      // window capture runs before the theme's own document-level handlers (they open the cart drawer)
      addEventListener('click', guard, true);
      addEventListener('submit', guard, true);

      // ---------- sticky buy bar (r5) ----------
      // One floating layer on a phone. It shows once the hero button has scrolled away and hides while the buy area is on
      // screen (about 2,300px had no button). Its label follows the choice: "לבחירת ערכה" scrolls to the picker (Shrine's
      // own behaviour); once pack, side and size are chosen it reads "הוספה לסל" and adds through the main button.
      const sticky = $('sticky-atc');
      if (sticky && 'IntersectionObserver' in window) {
        const heroEl = $('.lz-hero__cta') || $('.lz-hero');
        // the whole product block (gallery and picker): the bar covered the gallery dots on a phone (review 2)
        const buyEl = vsel.closest('product-info') || vsel.closest('.product__info-container') || vsel;
        let buyIn = false;
        // r7: the hero's button is now low in the opening's buy box, and a jump past it (an in-page link, a fast fling)
        // never makes it intersect, so the observer saw no change: whether it is above the screen is read on scroll
        const place = () => { const on = (!heroEl || heroEl.getBoundingClientRect().bottom < 0) && !buyIn; sticky.classList.toggle('lz-sticky-on', on); sticky.classList.toggle('lz-sticky-off', !on); sticky.inert = !on; };
        const io = new IntersectionObserver(es => es.forEach(e => { if (e.target === buyEl) buyIn = e.isIntersecting; place(); }), { threshold: 0 });
        io.observe(buyEl);
        let queued = false;
        addEventListener('scroll', () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; place(); }); }, { passive: true });
        place();
        const sBtn = $('button', sticky), sTxt = $('.sticky-atc__label__text', sticky);
        const ready = () => st.pair ? st.chosen : st.chosen && st.side;
        const label = () => { if (sTxt) { const t = ready() ? 'הוסף לסל' : 'בחר ערכה'; if (sTxt.textContent.trim() !== t) sTxt.textContent = t; } };
        new MutationObserver(label).observe(vsel, { childList: true, subtree: true });
        document.addEventListener('change', () => setTimeout(label, 0), true);
        vsel.addEventListener('click', () => setTimeout(label, 0));
        label();
        if (sBtn) sBtn.addEventListener('click', e => {
          if (!ready()) return; // Shrine scrolls to the picker
          e.preventDefault(); e.stopImmediatePropagation();
          const main = $('product-form button[type="submit"], .product-form__submit');
          main && main.click();
        }, true);
      }
    }

    // ---------- hero buy box (r7) ----------
    // Roi 30.10 evening (EVOLVE4 role 8: the offer and its button above the fold): kit, side and size in the opening,
    // added straight to the cart drawer the way the theme adds (the drawer's sections come back with the add). Nothing
    // is chosen for the reader except the first kit; "add" asks for what is missing, like the buy area lower down.
    $$('[data-lz-hbuy]').forEach(box => {
      let V = [];
      try { V = JSON.parse(($('[data-lz-variants]', box) || {}).textContent || '[]'); } catch (e) { V = []; }
      const st = { pack: null, pair: false, side: null, size: null, r: null, l: null };
      const packs = $$('.lz-hbuy__pack', box);
      const kitOpts = $('[data-kit-opts]', box), pairOpts = $('[data-pair-opts]', box);
      const err = $('.lz-size-error', box), add = $('[data-lz-add]', box), priceEl = $('[data-lz-price]', box);
      const check = (b) => { const g = b.closest('[role="radiogroup"]'); $$('[role="radio"]', g).forEach(x => x.setAttribute('aria-checked', String(x === b))); };
      const hideErr = () => { err.hidden = true; err.textContent = ''; };
      const render = () => {
        kitOpts.hidden = st.pair; pairOpts.hidden = !st.pair;
        $$('[data-label]', box).forEach(x => { const v = st[x.dataset.label]; x.textContent = v || (x.dataset.label === 'side' ? 'בחר צד' : 'בחר מידה'); });
        const p = packs.find(x => x.getAttribute('aria-checked') === 'true');
        if (priceEl) priceEl.textContent = p ? p.dataset.price : '';
      };
      const pickPack = b => { check(b); const pair = b.dataset.pair === '1'; if (pair !== st.pair) { st.side = st.size = st.r = st.l = null; $$('[data-opt]', box).forEach(x => x.setAttribute('aria-checked', 'false')); } st.pack = b.dataset.pack; st.pair = pair; };
      const first = packs.find(x => x.getAttribute('aria-checked') === 'true') || packs[0];
      if (first) pickPack(first);
      box.addEventListener('click', e => {
        const pk = e.target.closest('.lz-hbuy__pack');
        if (pk) { pickPack(pk); hideErr(); render(); return; }
        const b = e.target.closest('[data-opt]');
        if (b) { st[b.dataset.opt] = b.dataset.value; check(b); hideErr(); render(); return; }
        if (e.target.closest('[data-lz-chart]')) { const c = $('.sizing-chart__button'); c && c.click(); }
      });
      const missing = () => st.pair
        ? (!st.r || !st.l ? ['בחר מידה לכל ברך לפי טבלת המידות, ואז הוסף לסל', !st.r ? 'r' : 'l'] : null)
        : (!st.side && !st.size ? ['בחר צד ומידה, ואז הוסף לסל', 'side'] : !st.side ? ['בחר צד, ימין או שמאל, ואז הוסף לסל', 'side'] : !st.size ? ['בחר מידה לפי טבלת המידות, ואז הוסף לסל', 'size'] : null);
      const variant = () => st.pair
        ? V.find(v => v.o[0] === st.pack && v.o[2] === `ימין ${st.r} · שמאל ${st.l}`)
        : V.find(v => v.o[0] === st.pack && v.o[1] === st.side && v.o[2] === st.size);
      const showErr = (text, opt) => {
        err.textContent = text; err.hidden = false;
        const g = opt && $(`[data-opt="${opt}"]`, box);
        const row = g && g.closest('.lz-hbuy__row');
        (row || err).scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        g && g.focus({ preventScroll: true });
      };
      add && add.addEventListener('click', async () => {
        const m = missing(); if (m) { showErr(m[0], m[1]); return; }
        const v = variant();
        if (!v || !v.a) { showErr('הבחירה הזו לא זמינה כרגע. בחר מידה אחרת'); return; }
        add.disabled = true; add.classList.add('is-loading');
        try {
          const cart = $('cart-drawer');
          const sections = cart && cart.getSectionsToRender ? cart.getSectionsToRender().map(s => s.id) : [];
          const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          const r = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections, sections_url: location.pathname }) });
          const data = await r.json();
          if (!r.ok || data.status) throw new Error(data.description || 'add');
          if (cart && cart.renderContents && data.sections) { cart.renderContents(data); cart.classList.remove('is-empty'); }
          else location.href = `${root}cart`;
        } catch (e) {
          showErr('לא הצלחנו להוסיף לסל. נסה שוב בעוד רגע');
        } finally { add.disabled = false; add.classList.remove('is-loading'); }
      });
      render();
    });

    // ---------- small accessibility fixes on Shrine parts (r5) ----------
    // FAQ rows are visually small headings but every one was an H2; screen readers get level 3 under the section's H2.
    $$('main .accordion__title').forEach(h => { if (/^H\d$/.test(h.tagName)) { h.setAttribute('role', 'heading'); h.setAttribute('aria-level', '3'); } });
    // the theme's video play button has no name; icon ligatures ("verified", "straighten") are read aloud as words
    $$('.internal-video__play').forEach(b => { if (!b.getAttribute('aria-label')) b.setAttribute('aria-label', 'הפעלת הסרטון'); });
    $$('.material-symbols-outlined, .material-icon').forEach(i => i.setAttribute('aria-hidden', 'true'));
    // review 2 (R2-09): an open question said "collapsed" to screen readers
    $$('main details').forEach(d => {
      const s = d.querySelector(':scope > summary'); if (!s) return;
      const set = () => s.setAttribute('aria-expanded', String(d.open));
      d.addEventListener('toggle', set); set();
    });
    // review 2 (R2-10): the neutral buy page had no H1; its "choose a kit" heading is the page's heading
    if (!$('main h1')) {
      const h = $('main .product__info-wrapper h2.heading, main .product__info-container h2.heading');
      if (h) { const n = document.createElement('h1'); [...h.attributes].forEach(x => n.setAttribute(x.name, x.value)); n.append(...h.childNodes); h.replaceWith(n); }
    }
    // review 2 (R2-08): the menu's close button had no name, and Esc left the menu button saying "expanded"
    $$('.menu-drawer__close-btn').forEach(b => { if (!b.getAttribute('aria-label')) b.setAttribute('aria-label', 'סגירת התפריט'); });
    $$('header-drawer details').forEach(d => {
      const s = d.querySelector(':scope > summary'); if (!s) return;
      new MutationObserver(() => { const v = String(d.hasAttribute('open')); if (s.getAttribute('aria-expanded') !== v) s.setAttribute('aria-expanded', v); }).observe(d, { attributes: true, attributeFilter: ['open'] });
    });
    // review 2 (R2-07): while the cart drawer is open, Tab stays inside it (the page behind is inert)
    const cartSec = $('#shopify-section-cart-drawer');
    if (cartSec) {
      let made = [];
      const apply = () => {
        const drawer = $('cart-drawer', cartSec);
        const open = !!drawer && drawer.classList.contains('active');
        if (open && !made.length) {
          made = [...document.body.children].filter(el => !el.contains(cartSec) && !/^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(el.tagName) && !el.inert);
          made.forEach(el => { el.inert = true; });
        } else if (!open && made.length) { made.forEach(el => { el.inert = false; }); made = []; }
      };
      new MutationObserver(apply).observe(cartSec, { attributes: true, attributeFilter: ['class'], subtree: true, childList: true });
    }

    // ---------- layers (r6): a numbered point on the picture opens that part in the list; one part open at a time ----------
    $$('[data-lz-layers]').forEach(sec => {
      const parts = $$('details[data-lz-layer]', sec), hots = $$('[data-lz-hot]', sec);
      const mark = () => parts.forEach(d => { const h = hots.find(x => x.dataset.lzHot === d.dataset.lzLayer); if (h) { h.setAttribute('aria-expanded', String(d.open)); h.classList.toggle('is-on', d.open); } });
      parts.forEach(d => d.addEventListener('toggle', () => { if (d.open) parts.forEach(o => { if (o !== d && o.open) o.open = false; }); mark(); }));
      hots.forEach(h => h.addEventListener('click', () => {
        const d = parts.find(x => x.dataset.lzLayer === h.dataset.lzHot); if (!d) return;
        d.open = !d.open;
        if (d.open) { const r = d.getBoundingClientRect(); if (r.top < 0 || r.bottom > innerHeight) d.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }
      }));
      mark();
    });

    // r6: the kit names in Shrine's card titles get the brand green ("ערכת לזוז", "ערכת תזוזה מלאה")
    $$('main .multicolumn-card__info h3').forEach(h => { if (h.children.length || !/ערכת (לזוז|תזוזה מלאה)/.test(h.textContent)) return; h.innerHTML = h.textContent.replace(/[<>&]/g, '').replace(/(תזוזה מלאה|לזוז)/, '<em>$1</em>'); });

    // ---------- keep campaign parameters on links to the product pages ----------
    if (keep.length) $$('a[href*="/products/"]').forEach(l => { l.href = withKeep(l.getAttribute('href')); });

    // ---------- review list: "more reviews" opens the next cards; focus moves to the first new one ----------
    $$('[data-lz-reviews]').forEach(list => {
      const btn = $('[data-lz-more]', list.parentElement); if (!btn) return;
      const step = Number(list.dataset.step) || 6;
      const rest = () => $$('.lz-card[hidden]', list);
      const label = () => { const n = rest().length; btn.textContent = `עוד ${Math.min(step, n)} ביקורות`; btn.closest('.lz-reviews__more').hidden = !n; };
      btn.addEventListener('click', () => {
        const next = rest().slice(0, step);
        next.forEach(c => { c.hidden = false; });
        if (next[0]) { next[0].tabIndex = -1; next[0].focus({ preventScroll: true }); }
        label();
      });
      label();
    });

    // ---------- quiz ----------
    const quiz = $('[data-lz-quiz]');
    if (quiz) initQuiz(quiz);
  });

  function initQuiz(root) {
    const C = JSON.parse($('[data-lz-quiz-config]', root).textContent);
    // angles: one line per Q1 answer, "A3: 8 7 7 7" = angle for B1, B2, B3 and for a skipped Q2
    if (typeof C.angles === 'string') {
      C.angles = Object.fromEntries(C.angles.split(/\n+/).map(l => l.trim()).filter(l => l.includes(':')).map(l => {
        const [id, rest] = l.split(':');
        const [B1, B2, B3, skip] = rest.trim().split(/\s+/);
        return [id.trim(), { B1, B2, B3, skip }];
      }));
    }
    const steps = { 1: $('[data-lz-step="1"]', root), 2: $('[data-lz-step="2"]', root), 3: $('[data-lz-step="3"]', root) };
    const ids1 = C.q1.map(o => o.id), ids2 = C.q2.map(o => o.id);
    const read = () => {
      const p = new URLSearchParams(location.search);
      const q1 = ids1.includes(p.get('q1')) ? p.get('q1') : null;
      const q2 = ids2.includes(p.get('q2')) ? p.get('q2') : null;
      let step = Number(p.get('step')) || 1;
      if (step >= 2 && !q1) step = 1;
      if (step === 3 && !q2 && p.get('skip2') !== '1') step = 2;
      return { step, q1, q2, skip2: p.get('skip2') === '1' };
    };
    const write = (s, push) => {
      const p = new URLSearchParams(keep);
      p.set('step', s.step);
      if (s.q1) p.set('q1', s.q1);
      if (s.q2) p.set('q2', s.q2);
      if (s.skip2) p.set('skip2', '1');
      history[push ? 'pushState' : 'replaceState'](null, '', '?' + p.toString() + location.hash);
    };
    // Destination for a pair of answers (q2 null = skipped).
    const dest = (q1, q2) => {
      const o1 = C.q1.find(o => o.id === q1);
      const row = C.angles[q1] || {};
      const angle = q2 ? row[q2] : row.skip;
      const o2 = C.q2.find(o => o.id === q2);
      const tried = o2 && o2.tried && o2.tried !== 'none' ? o2.tried : null;
      return withKeep(C.base, { view: 'lazuz-' + o1.concept, a: angle && String(angle) !== '0' ? angle : null, tried, from: 'quiz' }); // r6: 0 = the default opening
    };
    window.lzQuizDest = dest; // used by the routing test

    let state = read(), timer = null, lastPointer = 0;
    const show = focus => {
      clearTimeout(timer);
      Object.entries(steps).forEach(([n, el]) => { el.hidden = Number(n) !== state.step; });
      $$('input[name="lz-q1"]', root).forEach(i => { i.checked = i.value === state.q1; });
      $$('input[name="lz-q2"]', root).forEach(i => { i.checked = i.value === state.q2; });
      // "not tried yet" contradicts a first answer about fiddling with a brace: hide it after that answer
      const usesBrace = (C.q1.find(o => o.id === state.q1) || {}).concept === 'support';
      $$('input[name="lz-q2"]', root).forEach(i => { const o = C.q2.find(x => x.id === i.value); i.closest('label').hidden = usesBrace && !!o && o.tried === 'none'; });
      $('[data-lz-next="1"]', root).disabled = !state.q1;
      $('[data-lz-next="2"]', root).disabled = !state.q2;
      $('[data-lz-q1-hint]', root).hidden = !!state.q1;
      if (state.step === 3) $('[data-lz-go]', root).href = dest(state.q1, state.skip2 ? null : state.q2);
      // r6: the last step names the moment the reader chose
      const mom = $('[data-lz-moment]', root), lab = state.q1 && $(`input[name="lz-q1"][value="${state.q1}"]`, root);
      if (mom) { const t = lab ? lab.closest('label').textContent.replace(/s+/g, ' ').trim() : ''; mom.textContent = t ? `הרגע שבחרת: ${t}` : ''; mom.hidden = !t; }
      if (focus) { const h = steps[state.step].querySelector('h1, h2'); h && h.focus(); }
    };
    const go = (step, push = true, focus = true) => { state.step = step; write(state, push); show(focus); };
    // r6 (Roi 30.10): no "done" screen. The second answer takes the reader straight to the page; the quiz state stays in
    // the address first, so the browser's Back returns to question 2 with the answer marked.
    // A pointer choice acts at once; a keyboard choice (arrows move between answers) waits for "continue".
    const leave = () => { write(state, false); location.href = dest(state.q1, state.skip2 ? null : state.q2); };
    const pick = (name, ev) => {
      const v = ev.target.value;
      if (name === 'q1') { state.q1 = v; state.q2 = null; state.skip2 = false; } else { state.q2 = v; state.skip2 = false; }
      write(state, false); show(false);
      const pointer = lastPointer && Date.now() - lastPointer < 800;
      if (!pointer) return;
      if (name === 'q1') timer = setTimeout(() => go(2), 260); else leave();
    };
    document.addEventListener('pointerdown', () => { lastPointer = Date.now(); }, true);
    $$('input[name="lz-q1"]', root).forEach(i => i.addEventListener('change', e => pick('q1', e)));
    $$('input[name="lz-q2"]', root).forEach(i => i.addEventListener('change', e => pick('q2', e)));
    // picking the answer that is already marked (after Back) fires no "change": a click on it still leaves
    $$('input[name="lz-q2"]', root).forEach(i => i.closest('label').addEventListener('click', () => { if (i.checked && state.q2 === i.value) setTimeout(leave, 0); }));
    $('[data-lz-next="1"]', root).addEventListener('click', () => state.q1 && go(2));
    $('[data-lz-next="2"]', root).addEventListener('click', () => state.q2 && leave());
    $$('[data-lz-back]', root).forEach(b => b.addEventListener('click', () => go(Number(b.dataset.lzBack))));
    $('[data-lz-q2-skip]', root).addEventListener('click', () => { state.q2 = null; state.skip2 = true; leave(); });
    $('[data-lz-q1-skip]', root).href = withKeep(C.base, { view: 'lazuz-' + C.skip.concept, a: C.skip.angle, from: 'quiz' });
    addEventListener('popstate', () => { state = read(); show(true); });
    write(state, false); show(false);
  }
})();
